import styled from 'styled-components';

export const KpiRow = styled.div`
    display: flex;
    gap: var(--spacer-S);
    margin-bottom: var(--spacer-M);
    flex-wrap: wrap;
`;

export const KpiCard = styled.div`
    flex: 1;
    min-width: 140px;
    max-width: 220px;
    padding: var(--spacer-S);
    background-color: var(--bg-light);
    border: var(--border-thin) solid var(--appLigthGrey);
    border-radius: var(--spacer-XXS);
    text-align: center;
`;

export const KpiValue = styled.div`
    font-size: 1.8em;
    font-weight: 700;
    color: var(--text-strong);
`;

export const KpiLabel = styled.div`
    font-size: 0.85em;
    color: var(--text-muted);
    margin-top: var(--spacer-XXS);
`;
